import { Dropdown, IOption } from "@faire/web--source/slate/Dropdown";
import { useField } from "formik";
import React, { ComponentProps, useCallback } from "react";

// omitting the value prop from the Dropdown component because we don't want it to be a controlled component
type IProps<T extends string = string> = Omit<
  ComponentProps<typeof Dropdown<T>>,
  "onSelect"
> & {
  name: string;
  onSelect?: (value: IOption<T>) => void;
  trackChange?: (name: string, value: string) => void;
};

export const FormikDropdown = <T extends string = string>({
  name,
  onSelect,
  trackChange,
  ...props
}: IProps<T>): React.ReactElement => {
  const [fields, { error, touched }, { setValue }] = useField<T>(name);

  const handleSelect = useCallback(
    (option: IOption<T>) => {
      onSelect?.(option);
      trackChange?.(name, option.value);
      setValue(option.value);
    },
    [name, onSelect, setValue, trackChange]
  );

  return (
    <Dropdown<T>
      {...fields}
      {...props}
      error={touched && error}
      onSelect={handleSelect}
    />
  );
};
